export const animatedIconMap: Record<string, string> = {
  // Clear sky
  "01d":
    "https://basmilius.github.io/meteocons/production/fill/svg/clear-day.svg",
  "01n":
    "https://basmilius.github.io/meteocons/production/fill/svg/clear-night.svg",

  // Few clouds
  "02d":
    "https://basmilius.github.io/meteocons/production/fill/svg/partly-cloudy-day.svg",
  "02n":
    "https://basmilius.github.io/meteocons/production/fill/svg/partly-cloudy-night.svg",

  // Scattered clouds
  "03d":
    "https://basmilius.github.io/meteocons/production/fill/svg/cloudy.svg",
  "03n":
    "https://basmilius.github.io/meteocons/production/fill/svg/cloudy.svg",

  // Broken clouds
  "04d":
    "https://basmilius.github.io/meteocons/production/fill/svg/overcast-day.svg",
  "04n":
    "https://basmilius.github.io/meteocons/production/fill/svg/overcast-night.svg",

  // Shower rain
  "09d":
    "https://basmilius.github.io/meteocons/production/fill/svg/partly-cloudy-day-rain.svg",
  "09n":
    "https://basmilius.github.io/meteocons/production/fill/svg/partly-cloudy-night-rain.svg",

  // Rain
  "10d":
    "https://basmilius.github.io/meteocons/production/fill/svg/rain.svg",
  "10n":
    "https://basmilius.github.io/meteocons/production/fill/svg/rain.svg",

  // Thunderstorm
  "11d":
    "https://basmilius.github.io/meteocons/production/fill/svg/thunderstorms-day.svg",
  "11n":
    "https://basmilius.github.io/meteocons/production/fill/svg/thunderstorms-night.svg",

  // Snow
  "13d":
    "https://basmilius.github.io/meteocons/production/fill/svg/snow.svg",
  "13n":
    "https://basmilius.github.io/meteocons/production/fill/svg/snow.svg",

  // Mist / Fog
  "50d":
    "https://basmilius.github.io/meteocons/production/fill/svg/mist.svg",
  "50n":
    "https://basmilius.github.io/meteocons/production/fill/svg/mist.svg",
};
